const globalActionsTypes = {
    MODULE_PARAMETERS_LOADED: "MODULE_PARAMETERS_LOADED"
};

export default globalActionsTypes;